export const VMI_PLATE_PREFIXES = {
	// '110': ['ภค', 'กร', '1กก'],
	// '110.1': ['ภค', 'กร', '1กก'],
	// '320': ['อธ', 'รฬ', 'ตน'],
	// '320.1': ['อธ', 'รฬ', 'ตน'],
}

export const validatePlateFormat = (plate) => {
	if (!plate) return false
	if (plate === 'ป้ายแดง') return true
	return /[0-9]$/.test(plate)
}

export const validateVmiPlate = (plate, carCode) => {
	if (!plate || !carCode) return true
	const prefixes = VMI_PLATE_PREFIXES[carCode]
	if (!prefixes) return true
	return prefixes.some((prefix) => plate.startsWith(prefix))
}
